export enum OrganisationStatus {
  NEW = 'NEW',
  SEND_OFFER = 'SEND_OFFER',
  OFFER_SEND = 'OFFER_SEND',
  AWAITING_DOCUMENTS = 'AWAITING_DOCUMENTS',
  CHECKING_COMPLETENESS = 'CHECKING_COMPLETENESS',
  CUSTOMER = 'CUSTOMER',
}
